// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.classification-footer[data-v-7ba5bd90] {\n  z-index: 1000;\n  position: fixed;\n  text-align: center;\n  left: 0;\n  right: 0;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
